export default __webpack_public_path__ + "static/media/Web-Development-Illustration2.5a4390fe.png";